const getDriverName = (trikeId, trikeList = []) => {
  if (trikeList.length === 0) return '';

  const record = trikeList.find((item) => item.IDNumber === trikeId) || {};

  return record?.driverName || '';
};

export default getDriverName;
